var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOptedOut = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.518 65.518",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.759 0C14.696 0 0 14.695 0 32.759s14.695 32.759 32.759 32.759 32.759-14.695 32.759-32.759S50.822 0 32.759 0zM6 32.759C6 18.004 18.004 6 32.759 6c6.648 0 12.734 2.443 17.419 6.472L12.472 50.178C8.443 45.493 6 39.407 6 32.759zm26.759 26.759a26.617 26.617 0 0 1-15.895-5.248l37.405-37.405a26.617 26.617 0 0 1 5.248 15.895c.001 14.754-12.003 26.758-26.758 26.758z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOptedOut, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/optedOut.37ca3818.svg";
export { ForwardRef as ReactComponent };